import styled from "styled-components";
import { COLORS, FONTS, HELPERS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const CategoriesStyled = styled.div`
  ul {
    list-style-type: none;
    padding: 0;
    li {
      cursor: pointer;
      width: 100%;
      padding: 16px 12px;
      border-bottom: 1px solid ${COLORS.GRAY_THREE};
      transition: ${HELPERS.TRANSITION};
      &:hover {
        color: ${COLORS.BLUE};
      }
      &.active {
        font-weight: ${FONTS.FONT_WEIGHT_SEMI_BOLD};
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    ul {
      li {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: auto;
        height: auto;
        font-size: 14px;
        border: 1px solid ${COLORS.GRAY_THREE};
        margin-right: 5px;
        margin-bottom: 5px;
        padding: 7.5px;
        border-radius: 7.5px;
        font-size: 12px;
        &.active {
          color: ${COLORS.WHITE};
          background: ${COLORS.PRIMARY_DARK};
          border: 1px solid ${COLORS.PRIMARY_DARK};
          font-weight: normal;
        }
      }
    }
  }
`;
